export const defaultStyles = {
  color: "var(--theme-website-p1-color-text)",
  fontWeight: "var(--theme-website-p1-font-weight)",
  fontSize: "var(--theme-website-p1-font-size)",
  lineHeight: "var(--theme-website-p1-line-height)",
  fontFamily: "var(--theme-website-p1-font-family)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;

export const p2DefaultStyles = {
  color: "var(--theme-website-p2-color-text)",
  fontWeight: "var(--theme-website-p2-font-weight)",
  fontSize: "var(--theme-website-p2-font-size)",
  lineHeight: "var(--theme-website-p2-line-height)",
  fontFamily: "var(--theme-website-p2-font-family)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;

export const p3DefaultStyles = {
  color: "var(--theme-website-p3-color-text)",
  fontWeight: "var(--theme-website-p3-font-weight)",
  fontSize: "var(--theme-website-p3-font-size)",
  lineHeight: "var(--theme-website-p3-line-height)",
  fontFamily: "var(--theme-website-p3-font-family)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;
